import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api } from "@/api";

export const Messages = () => {
  const [messages, setMessages] = useState([]);

  const load = () => api.get("/contact").then((r) => setMessages(r.data)).catch(() => {});

  useEffect(() => { load(); }, []);

  const del = async (m) => {
    try {
      await api.delete(`/contact/${m.id}`);
      setMessages(messages.filter((x) => x.id !== m.id));
      toast.success("Mesaj silindi");
    } catch {
      toast.error("Silme başarısız");
    }
  };

  return (
    <div className="bg-white border border-stone-200 p-8" data-testid="messages-tab">
      {messages.length === 0 ? (
        <p className="text-stone-500 font-light" data-testid="messages-empty">Henüz mesaj yok.</p>
      ) : (
        <ul className="divide-y divide-stone-100">
          {messages.map((m) => (
            <li key={m.id} className="py-5 flex items-start justify-between gap-6" data-testid={`message-row-${m.id}`}>
              <div>
                <p className="font-medium text-stone-800">{m.name} <span className="text-stone-400 font-light text-sm">— {m.email}{m.phone ? ` · ${m.phone}` : ""}</span></p>
                <p className="text-stone-600 font-light text-sm mt-1 leading-relaxed">{m.message}</p>
                <p className="text-stone-400 text-xs mt-2">{new Date(m.created_at).toLocaleString("tr-TR")}</p>
              </div>
              <button onClick={() => del(m)} className="p-2 text-stone-400 hover:text-red-700 shrink-0" data-testid={`message-delete-${m.id}`} aria-label="Sil">
                <Trash2 size={15} />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
